import { Component, Mixins, Prop, Ref, Vue, Watch } from 'vue-property-decorator'

@Component
export default class RegionSelect extends Vue {

  @Prop({ required: true })
  private value!: string

  private states = [
    { header: 'Österreich' },
    'Burgenland',
    'Kärnten',
    'Niederösterreich',
    'Oberösterreich',
    'Salzburg',
    'Steiermark',
    'Tirol',
    'Vorarlberg',
    'Wien',
    { header: 'Deutschland' },
    'Baden-Württemberg',
    'Bayern',
    'Berlin',
    'Brandenburg',
    'Bremen',
    'Hamburg',
    'Hessen',
    'Mecklenburg-Vorpommern',
    'Niedersachsen',
    'Nordrhein-Westfalen',
    'Rheinland-Pfalz',
    'Saarland',
    'Sachsen',
    'Sachsen-Anhalt',
    'Schleswig-Holstein',
    'Thüringen',
  ]

  private region = this.value

  @Watch('value')
  private valueChanged(val: string, old: string) {
    if (val != old) {
      this.region = val
    }
  }

  @Watch('region')
  private regionChanged(val: string, old: string) {
    if (val != old) {
      this.$emit('input', val)
    }
  }
}
